<template>

  <div>

  <TemplateModal
    v-bind:modalId="modalId">
      
    <h4 slot="modal-title" class="modal-title">
      Snatch Car Park ID
    </h4>

    <div slot="modal-body">

      <vue-tags-input
          placeholder="Add Snatch Car Park IDs"
          v-show="visible"
          v-model="tag"
          :tags="tags"
          @tags-changed="newTags => tags = newTags"
          :disabled="!allowEdit"
        />

      <TemplateFeedback ref="modalFeedback" />
    </div>

    <div slot="modal-footer">
      <slot name="modal-footer-before"/>
      <button type="button" class="btn btn-default" data-dismiss="modal">
        Close
      </button>
      <button v-show="false" @click="onSaveClick" type="button" class="btn btn-success">
        Save
      </button>
    </div>

  </TemplateModal>

  </div>

</template>

<script>
import AppForm from "@/components/App/AppForm";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import TemplateModal from "@/components/Template/TemplateModal";
import TemplateButton from "@/components/Template/TemplateButton";
import helper from "@/components/Utility/Helper"
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  name: "AppModalForm",
  props: {
    'formParameter': null,

    'modalShowDelete': {
      default: true
    },
    'modalShowEdit': {
      default: true
    },
    'modalShowAdd' : {
      default: true
    },
  },
  components: {
    AppForm,
    TemplateFeedback,
    TemplateModal,
    TemplateButton,
    VueTagsInput,
  },
  data () {
    return {
      modalId: null,
      modalTitle: '',
      modalData: null,

      permission: 'carpark.cpid_edit',
      visible: false,

      carparkID: '',

      tag: '',
      tags: [],

      allowEdit: false,
    }
  },
  mounted() {
    this.modalId = "jt-popup-modal-" + this._uid;
    this.allowEdit = helper.hasPermission(this.permission, false)
    this.allowEdit = false
    this.visible = false
  },
  methods: {
    setModalOpen(carparkID) {
      this.carparkID = carparkID

      this.visible = false
      this.$refs['modalFeedback'].setFeedbackLoading('Loading Snatch Car Park ID');
        
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.carparkID + '/reference',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data.references) {
            this.tags = response.data.references.map(k => k.referenceID)
            this.visible = true
            this.$refs['modalFeedback'].setFeedbackMessage();
          } else {
            this.$refs['modalFeedback'].setFeedbackError('Problem loading Snatch Car Park ID.');
          }
        })
        .catch(error => {
          this.$refs['modalFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'Snatch Car Park ID'));
        })

      $('#' + this.modalId).modal('show');
    },
    setModalClose() {
      this.$refs['modalFeedback'].setFeedbackMessage(null);
      $('#' + this.modalId).modal('hide');
    },
    setModalLoading(message) {
      this.$refs['modalFeedback'].setFeedbackLoading(message);
    },
    setModalError(error) {
      this.$refs['modalFeedback'].setFeedbackError(error);
    },
    setModalMessage(message) {
      this.$refs['modalFeedback'].setFeedbackMessage(message);
    },

    onSaveClick() {
      let temp = this.tags.map(k => k.text)
      this.$refs['modalFeedback'].setFeedbackLoading('Saving Snatch Car Park ID');
      
      let config = helper.createAxiosConfig()
      // config['headers']['content-type'] = 'application/json'

      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + this.carparkID + '/reference',
          {
            referenceIDs: temp, 
          },
          config,
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data) {
            this.visible = true
            this.$refs['modalFeedback'].setFeedbackMessage();
            $('#' + this.modalId).modal('hide');
          } else {
            this.$refs['modalFeedback'].setFeedbackError('Problem saving Snatch Car Park ID.');
          }
        })
        .catch(error => {
          this.$refs['modalFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'saving', 'Snatch Car Park ID'));
        })
    },

    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
    hasEditPermission() {
      return helper.hasEditPermission(this.permission);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Page/CarPark/PageCarParkParkAideIDPopup.vue